import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  client_fullname?: string;
};
const ClientCell = React.memo((row: KpiWorkunitGridData) => (
  <span>
    {row?.client_fullname && (
      <Tooltip title={row.client_fullname}>
        <Typography variant="body2" noWrap>
          {row.client_fullname}
        </Typography>
      </Tooltip>
    )}
  </span>
));

export default ClientCell;
